import {
  SocureDeviceOptions,
  SocureConfigs,
  SocureSessionData,
  SOCURE_SESSION_DATA
} from '../domain/socure'

/**
 * https://developer.socure.com/docs/sdks/sigma-device/js-sdk/js-overview
 *
 * Note: `deviceSessionId` is returned, and can be accessed via callback.
 * However, it is also stored/accessible via browser cache/cookie
 */
export const initSocure = (config: SocureConfigs): void => {
  window.devicer.run(options(config), (response: SocureResponse) => {
    // No action
  })
}

const options = ({
  config: {
    variables: { SOCURE_PUBLIC_KEY }
  },
  context
}: SocureConfigs): SocureDeviceOptions => ({
  publicKey: SOCURE_PUBLIC_KEY,
  context,
  userConsent: true // hardcoded to mirror app
})

const parseDeviceSessionData = (sessionData: string): SocureSessionData =>
  JSON.parse(sessionData)

export const deviceSessionId = (): string | undefined => {
  const sessionData = localStorage.getItem(SOCURE_SESSION_DATA)

  return sessionData ? parseDeviceSessionData(sessionData).value : undefined
}

type SocureResponse = {
  sessionId: string // JWT format
  result: 'Captured' | 'Ignored' // tied to `userConsent`
}

// typescript throws without this
declare global {
  interface Window {
    devicer: {
      run: any
    }
  }
}
